module.exports = __webpack_public_path__ + "static/img/1000000514_blue.17a51aa4.jpg";